import { render, staticRenderFns } from "./TestGet.vue?vue&type=template&id=473b9728"
import script from "./TestGet.vue?vue&type=script&lang=js"
export * from "./TestGet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports